import { useImpersonateState, useUserActions, useUserInfo, useUserToken } from "@/store/userStore";
import { useNavigate } from "react-router";
import accountsService from "@/api/services/accountsService";

export default function ImpersonateBanner() {
	const impersonate = useImpersonateState();
	const userInfo = useUserInfo();
	const userToken = useUserToken();
	const { stopImpersonate } = useUserActions();
	const navigate = useNavigate();

	if (!impersonate.isImpersonating) return null;

	const handleStop = async () => {
		try {
			await accountsService.stopImpersonate(userToken.accessToken || "");
		} catch {
			// Token may already be invalid, still restore admin
		}
		stopImpersonate();
		navigate("/workbench");
	};

	return (
		<div className="fixed top-0 left-0 right-0 z-[9999] bg-amber-500 text-black text-center py-2 px-4 text-sm font-medium flex items-center justify-center gap-3">
			<span>
				Megszemélyesítés aktív: <strong>{userInfo.name}</strong> felhasználóként vagy bejelentkezve
			</span>
			<button
				type="button"
				onClick={handleStop}
				className="bg-black text-white px-3 py-1 rounded text-xs font-bold hover:bg-gray-800 transition-colors"
			>
				Visszaváltás
			</button>
		</div>
	);
}
